/**
 * @callback EventHandler
 * @param {*} [context] - The context for the eventID that is happening
 */

/**
 * @typedef {Symbol|string} EventID
 */

export class LifecycleManager{
    constructor(){
        /**
         *
         * @type {Map<EventID, ([EventHandler, number])[]>}
         */
        this.events = new Map();
    }


    /**
     * @param {EventID} eventID - The eventID identifier
     * @param {EventHandler} method - The method to be called during this eventID
     * @param {Number} [priority=10]
     * @return {LifecycleManager}
     */
    registerEvent(eventID, method, priority=10){
        if(!this.events.has(eventID)){
            this.events.set(eventID,[]);
        }
        /** @type {[EventHandler, Number][] } */
        const handlers = this.events.get(eventID);
        handlers.push([method, priority])
        handlers.sort(([,a],[,b])=>a-b)
        this.events.set(eventID, handlers);
        return this;
    }

    /**
     *
     * @param {EventID} eventID the id of the event you want to call
     * @param {*} [context] any context you would like to pass along to your handler
     * @return {LifecycleManager}
     */
    callEvent(eventID, context){
        if(this.events.has(eventID))
        this.events.get(eventID).forEach(([handler])=>{
            handler(context)
        })
        return this;
    }
}